import React from "react";
import { Chip } from "@mui/material";
import { useTheme } from "@mui/material/styles";

function ChipDisplay({ setting, styles = {} }) {
  const theme = useTheme();
  return (
    <Chip
      sx={{
        backgroundColor: theme.palette?.[setting?.color]?.main,
        color: theme.palette.white.main,
        ...styles,
      }}
      key={setting.columnId}
      label={setting.field_value}
    />
  );
}

export default ChipDisplay;
